import React, { useEffect, useState } from "react"
import { FormTitle } from "../members/formComponents/FormTitle"
import { FormButton } from "../members/formComponents/FormButton"
import { Container, Form, Alert } from "reactstrap"
import { Trans } from "@lingui/react"
import { connect } from "react-redux"
import { toast } from "react-toastify"
import {
  cashoutStarted,
  confirmCashout,
  deleteCashoutvslaMembers,
  groupCashout,
  getCashoutDetails,
} from "../../store/reducers/cashout/actions"
import { t } from "@lingui/macro"
import { setCurrentPage, setPreviousPage } from "../../store/reducers/navigation"
import { fetchActiveMeetingTransactions } from "../../store/actions/meetings"
import StellarLoader from "../layout/StellarLoader"
import PropTypes from "prop-types"

const SuccessMessage = () => {
  return (
    <div style={successStyle}>
      <Trans id="notifications.cash_out_success_msg">Cash out completed</Trans>
    </div>
  )
}

const notify = (msg) => toast(msg)
const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "700",
  fontSize: "28px",
  lineHeight: "33.6px",
  textAlign: "center",
  paddingBottom: "0.5em",
}

const formHeaderStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "700",
  fontSize: "20px",
  lineHeight: "24px",
  textAlign: "center",
  paddingBottom: "0.5em",
}

const EndCycleCashout = (props) => {
  const [cashingOut, setCashingOut] = useState(false)
  const [cashoutBtnEnable, setCashoutBtnEnable] = useState(false)
  const [hideCashoutTypes, setHideCashoutTypes] = useState("")
  const [cashoutBreakDown, setCashoutBreakDown] = useState(props.cashoutBreakDown)
  const [memberDetails, setMemberDetails] = useState()

  const fetchData = async (memberDetails) => {
    const res = await props.getCashoutDetails(memberDetails, false)
    setCashoutBreakDown(res)
  }

  useEffect(() => {
    if (props.cashoutMembers[0]) fetchData(props.cashoutMembers[0])
    else setCashoutBreakDown([])
    setMemberDetails(props.cashoutMembers[0])
  }, [props.cashoutMembers])

  useEffect(() => {
    props.fetchActiveMeetingTransactions()
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()
    setCashoutBtnEnable(true)
    setCashingOut(true)
    setHideCashoutTypes("none")

    if (props.cashoutMembers.length) processCashOut()
  }

  const processCashOut = async () => {
    const { meeting, cashoutMembers, user } = props
    const meetingId = meeting?.id
    const groupId = meeting?.group_id
    const userId = user?.id

    await props.confirmCashout(
      memberDetails.blockchain_wallet_id,
      meetingId,
      groupId,
      userId,
    )
    setCashoutBtnEnable(false)
    setCashingOut(false)
    setHideCashoutTypes("")
    setCashoutBreakDown()
    setMemberDetails()
    props.delCashoutMembers(memberDetails.blockchain_wallet_id)

    notify(<SuccessMessage />)
    console.log("cashoutMembers", cashoutMembers)
    if (cashoutMembers.length === 1) {
      await props.confirmCashout(
        memberDetails.blockchain_wallet_id,
        meetingId,
        groupId,
        userId,
      )
      props.groupCashout(groupId)
      props.cashoutStarted(false)
      props.setPreviousPage("group-endOfCycleCashout")
      props.setPage("group-memberList")
      return
    }
  }

  const hasTransaction = (e) => {
    if (props.transactions.length) {
      e.preventDefault()
      alert(
        t({
          id: "You cannot edit settings while there are pending transactions",
        }),
      )
      return
    }
    props.setPage("group-settings")
  }

  if (typeof cashoutBreakDown === "undefined") {
    return <StellarLoader />
  }
  const { cashoutMembers } = props

  return (
    <Container>
      <div>
        {memberDetails && <h4 style={headerStyle}>{memberDetails.full_name}</h4>}
      </div>
      <FormTitle style={formHeaderStyle} title="End-cycle cash out" />

      <Form onSubmit={onSubmit}>
        <br />

        {cashoutMembers.length === 0 && (
          <Alert color="danger">
            <h4>
              <Trans id="alert.error">Error</Trans>
            </h4>
            <span>
              <Trans id="alert.all_members_cashed_out">
                All members have been cashed out
              </Trans>
            </span>
          </Alert>
        )}

        {memberDetails && cashoutBreakDown?.balances && Array.isArray(cashoutBreakDown.balances) && (
          <ul style={{ listStyle: "none" }}>
            {cashoutBreakDown.balances.map((item) => (
              <li key={item.fundName} style={{ padding: "4px 0" }}>
                {`${item.fundName}: ${item.amount}`}{" "}
              </li>
            ))}
          </ul>
        )}

        <br />
        {cashoutMembers.length === 1 && cashoutMembers.length > 0 && (
          <FormButton
            type={"submit"}
            value={
              cashingOut ? t`cashOut.cashingOut` : t`cashOut.finish`
            }
            name="submit"
            className="btn btn-lg form-control"
            disabled={cashoutBtnEnable}
          />
        )}
        {cashoutMembers.length > 1 && (
          <FormButton
            id="active-primary-btn"
            type={"submit"}
            value={
              cashingOut ? t`cashOut.cashingOut` : t`cashOut.next`
            }
            name="submit"
            className="btn btn-lg form-control"
            disabled={cashoutBtnEnable}
          />
        )}
      </Form>

      <Alert color="info" style={{ display: hideCashoutTypes }}>
        <p>
          <Trans id="cashOut.settings_summary_title">Cashout Settings Summary</Trans>
        </p>
        <p>
          <strong>
            <Trans id="cashOut.savings">Savings</Trans>
          </strong>
          : {props.group?.metadata?.savingsCashOutType}
        </p>
        <p>
          <strong>
            <Trans id="cashOut.loan_interest">Loan Interest</Trans>
          </strong>
          : {props.group?.metadata?.loanInterestCashOutType}
        </p>
        <p>
          <strong>
            <Trans id="cashOut.membership">Membership</Trans>
          </strong>
          : {props.group?.metadata?.membershipCashOutType}
        </p>
        <p>
          <strong>
            <Trans id="cashOut.welfare">Welfare</Trans>
          </strong>
          : {props.group?.metadata?.welfareCashOutType}
        </p>
        <p>
          <strong>
            <Trans id="cashOut.fine">Fine</Trans>
          </strong>
          : {props.group?.metadata?.fineCashOutType}
        </p>
        <br />
        <p>
          <Trans id="cashOut.call_to_action">
            To change any of these settings, please go to the settings page
          </Trans>{" "}
          <span
            className="sp-action"
            onClick={(e) => {
              hasTransaction(e)
            }}
          >
            <Trans id="cashOut.write_here">here</Trans>
          </span>
        </p>
      </Alert>
    </Container>
  )
}

const successStyle = {
  fontFamily: "quicksand",
  fontSize: "20px",
  color: "green",
  fontWeight: "bolder",
}

const mapStateToProps = (state) => {
  return {
    meeting: state.meeting?.ongoing,
    vsla: state.vsla,
    group: state.group,
    transactions: state.meetingTransactions,
    cashoutMembers: state.membersTocashout,
    user: state.user,
    vslaInfo: state.vsla,
  }
}

const mapDispatchToProps = (dispatch) => ({
  confirmCashout: (id, meetingId, group_id, userId) =>
    dispatch(confirmCashout(id, meetingId, group_id, userId)),
  delCashoutMembers: (state) => dispatch(deleteCashoutvslaMembers(state)),
  cashoutStarted: (state) => dispatch(cashoutStarted(state)),
  groupCashout: (group_id) => dispatch(groupCashout(group_id)),
  setPage: (page) => dispatch(setCurrentPage(page)),
  setPreviousPage: (page) => dispatch(setPreviousPage(page)),
  getCashoutDetails: (memberDetails, isMidCycle) =>
    dispatch(getCashoutDetails(memberDetails, isMidCycle)),
  fetchActiveMeetingTransactions: () => dispatch(fetchActiveMeetingTransactions()),
})

EndCycleCashout.propTypes = {
  cashoutBreakDown: PropTypes.array,
  getCashoutDetails: PropTypes.func,
  cashoutMembers: PropTypes.array,
  fetchActiveMeetingTransactions: PropTypes.func,
  meeting: PropTypes.array,
  user: PropTypes.object,
  confirmCashout: PropTypes.func,
  delCashoutMembers: PropTypes.func,
  groupCashout: PropTypes.func,
  cashoutStarted: PropTypes.func,
  setPreviousPage: PropTypes.func,
  setPage: PropTypes.func,
  transactions: PropTypes.array,
  vsla: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(EndCycleCashout)
